export default "__VITE_ASSET__C84EFqN8__"